import React, { useState, useEffect, useContext } from "react";
import Table from "../Homepage/Table";
import "../../css_files/Master/GSTMaster.css";
import AddGSTMaster from "./AddGSTMaster";
import SearchGSTMaster from "./SearchGSTMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function GSTMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Rate", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [gstupdatedata, setgstupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [gstId, setgstId] = useState(null);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  function fetchgstdata(gstid) {
    setgstupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/GST/GetGSTById?id=${gstid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setgstupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/api/v1/GST/${pagenumber}`, {
        Id: gstId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTableData(
          response.data.data.map((x) => [x.id, x.rate + " %", x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "GST" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "GST" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "GST" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "GST" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="gst-master">
      <h1>GST Master</h1>
      <blockquote className="gst-master-forms">
        <AddMaster
          text="Add GST Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search GST Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddGSTMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          gstupdatedata={gstupdatedata}
          key={`${gstupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchGSTMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setgstId={setgstId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchgstdata}
        url="GST/UpdateGST"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default GSTMaster;
